import { validatePresenceOf } from '@/shared/utils';

export const validate = (mention, options) => {
  return validatePresenceOf(mention, ['registry'], options);
};

export const buildContent = mention => {
  return mention.registry ? [`${mention.registry}.`] : [];
};
